class PressArticlesSlider extends HTMLElement {
    constructor() {
        super();
        this.currentIndex = 0;
        this.autoplayTimer = null;
    }

    connectedCallback () {
        this.slider = this.querySelector('.slider');
        if (!this.slider) return;

        this.wrapper = this.slider.querySelector('.slider-wrapper');
        this.slides = this.slider.querySelectorAll('.slider-slide');
        this.pagination = this.slider.querySelector('.slider-pagination');
        this.prevButton = this.slider.querySelector('.slider-button-prev');
        this.nextButton = this.slider.querySelector('.slider-button-next');

        if (!this.wrapper || this.slides.length === 0) return;

        this.totalSlides = this.slides.length;
        this.createDots();
        this.updateSlider();
        this.attachEvents();
    }

    createDots () {
        if (!this.pagination) return;
        this.pagination.innerHTML = '';
        this.slides.forEach((_, index) => {
            const dot = document.createElement('button');
            dot.classList.add('slider-dot');
            dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
            if (index === 0) dot.classList.add('active');

            dot.addEventListener('click', () => {
                this.currentIndex = index;
                this.updateSlider();
                this.resetAutoplay();
            });

            this.pagination.appendChild(dot);
        });

        this.dots = this.pagination.querySelectorAll('.slider-dot');
    }

    attachEvents () {
        if (this.nextButton) {
            this.nextButton.addEventListener('click', () => {
                this.currentIndex = (this.currentIndex + 1) % this.totalSlides;
                this.updateSlider();
                this.resetAutoplay();
            });
        }

        if (this.prevButton) {
            this.prevButton.addEventListener('click', () => {
                this.currentIndex =
                    (this.currentIndex - 1 + this.totalSlides) % this.totalSlides;
                this.updateSlider();
                this.resetAutoplay();
            });
        }

        // Optional autoplay — enable via data attributes if needed
        const speed = parseInt(this.dataset.speed) || 6000;
        const autoplay = this.hasAttribute('data-autoplay');
        if (autoplay) this.startAutoplay(speed);
    }

    updateSlider () {
        const offset = -(this.currentIndex * 100);
        this.wrapper.style.transform = `translateX(${offset}%)`;

        if (this.dots) {
            this.dots.forEach((dot, i) => {
                dot.classList.toggle('active', i === this.currentIndex);
            });
        }
    }

    startAutoplay (speed) {
        this.autoplayTimer = setInterval(() => {
            this.currentIndex = (this.currentIndex + 1) % this.totalSlides;
            this.updateSlider();
        }, speed);
    }

    resetAutoplay () {
        if (this.autoplayTimer) {
            clearInterval(this.autoplayTimer);
            const speed = parseInt(this.dataset.speed) || 6000;
            this.startAutoplay(speed);
        }
    }
}

window.customElements.define('press-articles-slider', PressArticlesSlider);